import axios from 'axios';

const axiosOptions = {
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    'https://h2tms.bte-inc.co.kr/api/bo',
  headers: {},
};

const axiosInstance = axios.create(axiosOptions);

const token = localStorage.getItem('@h2tms/token');
if (token) {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

axiosInstance.interceptors.response.use(
  ({ data }) => {
    // Invalid access token
    if (!data.success && data.data.message === 'invalid access token') {
      localStorage.clear();
      window.location.href = '/login';
      return;
    }

    console.debug(data);
    return data;
  },
  (error) => {
    return {
      success: false,
      data: { error },
    };
  },
);

export default axiosInstance;

export const setAuthToken = (newToken) => {
  axiosInstance.defaults.headers['Authorization'] = `Bearer ${newToken}`;
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
  localStorage.setItem('@h2tms/token', newToken);
};

export const removeAuthToken = () => {
  delete axiosInstance.defaults.headers['Authorization'];
  delete axiosInstance.defaults.headers.common['Authorization'];
  localStorage.clear();
};
